import React from 'react';

/**
 * Renders label color indicators.
 *
 * @param {Array} labels - [{ id, name, color }]
 * @param {'tabs' | 'dots'} variant - Visual style
 */
export default function LabelIndicators({ labels, variant = 'tabs' }) {
  if (!labels || labels.length === 0) return null;

  if (variant === 'dots') {
    return (
      <div className="label-dots">
        {labels.map((label) => (
          <span
            key={label.id}
            className="label-dot"
            style={{ background: `var(--label-${label.color})` }}
            title={label.name}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="label-tabs">
      {labels.map((label) => (
        <span
          key={label.id}
          className="label-tab"
          style={{ background: `var(--label-${label.color})` }}
          title={label.name}
        />
      ))}
    </div>
  );
}
